<template>
  <div
    v-if="showMenuOptions"
    class="tw-absolute tw-bottom-full tw-left-[8px] tw-z-[60] tw-mb-2 tw-flex tw-w-[244px] tw-flex-col tw-items-center tw-gap-2 tw-overflow-hidden tw-rounded-[16px] tw-border tw-border-[#E5E7EB] tw-bg-white tw-shadow-[0_4px_8px_0_rgba(0,0,0,0.25)]"
  >
    <div
      class="tw-left-[16px] tw-top-[-292px] tw-flex tw-w-[244px] tw-flex-col tw-items-center tw-rounded-lg tw-text-white tw-shadow-lg"
    >
      <!-- Share Group-->
      <button
        type="button"
        class="tw-order-1 tw-flex tw-h-[50px] tw-items-center tw-gap-[8px] tw-self-stretch tw-border-b tw-border-gray-200 tw-px-[24px] tw-py-[16px] hover:tw-bg-gray-100 focus-visible:tw-bg-gray-100 md:tw-hidden"
        @click="handleGroupShare"
      >
        <!-- SVG -->
        <ShareNetwork />
        <span
          class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-normal tw-text-[#3B4143]"
        >
          {{ shareGroupLabel }}
        </span>
      </button>

      <!-- Change Group-->
      <button
        type="button"
        class="tw-order-5 tw-flex tw-h-[50px] tw-items-center tw-gap-[8px] tw-self-stretch tw-border-t tw-border-gray-200 tw-px-[24px] tw-py-[16px] hover:tw-bg-gray-100 focus-visible:tw-bg-gray-100 md:tw-order-4"
        @click="$emit('open-context', 'change_group')"
      >
        <!-- SVG -->
        <ArrowsClockwise fill-color="#3B4143" />
        <span
          class="tw-font-inter tw-text-[16px] tw-leading-normal tw-text-[#3B4143]"
        >
          Change group
        </span>
      </button>

      <!-- Create New Group-->
      <button
        type="button"
        class="tw-order-4 tw-flex tw-h-[50px] tw-items-center tw-gap-[8px] tw-self-stretch tw-border-t tw-border-gray-200 tw-px-[24px] tw-py-[16px] hover:tw-bg-gray-100 focus-visible:tw-bg-gray-100 md:tw-order-3"
        @click="$emit('open-context', 'create_group')"
      >
        <!-- SVG -->
        <Users fill-color="#3B4143" />
        <span
          class="tw-font-inter tw-text-[16px] tw-leading-normal tw-text-[#3B4143]"
        >
          Create new group
        </span>
      </button>

      <!-- Manage Group -->
      <button
        type="button"
        class="tw-order-2 tw-flex tw-h-[50px] tw-items-center tw-justify-between tw-self-stretch tw-border-t tw-border-gray-200 tw-px-[24px] tw-py-[16px] hover:tw-bg-gray-100 focus-visible:tw-bg-gray-100 md:tw-order-1 md:tw-border-t-0"
        @click="$emit('open-context', 'manage_group')"
      >
        <span class="tw-flex tw-items-center tw-gap-[8px]">
          <UserCircleCheck />
          <span
            class="tw-font-inter tw-text-[16px] tw-leading-normal tw-text-[#3B4143]"
          >
            Manage group
          </span>
        </span>

        <span
          v-if="pendingJoinRequestsCount > 0"
          class="tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-bg-orange-500 tw-text-[11px] tw-font-semibold tw-leading-[16px] tw-tracking-tight tw-text-white"
        >
          {{ pendingJoinRequestsCount > 9 ? '9+' : pendingJoinRequestsCount }}
        </span>
      </button>

      <!-- Rename Group-->
      <button
        :disabled="!canRenameGroup"
        type="button"
        class="tw-order-3 tw-flex tw-h-[50px] tw-items-center tw-gap-[8px] tw-self-stretch tw-border-t tw-border-gray-200 tw-px-[24px] tw-py-[16px] hover:tw-bg-gray-100 focus-visible:tw-bg-gray-100 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 disabled:hover:tw-bg-none disabled:focus-visible:tw-bg-none md:tw-order-2"
        @click="$emit('open-context', 'rename_group')"
      >
        <!-- SVG -->
        <PencilSimpleLine />
        <span
          class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-normal tw-text-[#3B4143]"
        >
          Rename group
        </span>
      </button>

      <!-- Delete Group (only shown when deletable) -->
      <button
        v-if="canDeleteGroup && !isConfirmingDelete"
        type="button"
        class="tw-flex tw-h-[50px] tw-items-center tw-gap-[8px] tw-self-stretch tw-border-y tw-border-gray-200 tw-px-[24px] tw-py-[16px] hover:tw-bg-[#FEF2F2] focus-visible:tw-bg-[#FEF2F2]"
        @click="startDeleteConfirm"
      >
        <Trash />
        <span
          class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-normal tw-text-[#E7000B]"
        >
          Delete group
        </span>
      </button>

      <!-- Inline confirm row -->
      <div
        v-if="canDeleteGroup && isConfirmingDelete"
        class="tw-flex tw-h-[50px] tw-w-full tw-items-stretch tw-border-t tw-border-gray-200"
      >
        <button
          type="button"
          class="tw-flex tw-flex-1 tw-items-center tw-justify-start tw-border-y tw-px-[24px] tw-text-left hover:tw-bg-[#FEF2F2] focus-visible:tw-bg-[#FEF2F2]"
          @click="confirmDelete"
        >
          <span
            class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-normal tw-text-[#E7000B]"
          >
            Click to confirm
          </span>
        </button>

        <button
          type="button"
          class="tw-flex tw-w-[50px] tw-items-center tw-justify-center tw-border-y tw-border-l tw-border-[#E5E7EB] hover:tw-bg-gray-50 focus-visible:tw-bg-gray-50"
          aria-label="Cancel delete"
          @click="cancelDeleteConfirm"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18.75 5.25L5.25 18.75"
              stroke="#6B7280"
              stroke-width="2.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.75 18.75L5.25 5.25"
              stroke="#6B7280"
              stroke-width="2.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Trash from '@components/Student/SVG/Trash.vue';
import UserCircleCheck from '@components/Student/SVG/UserCircleCheck.vue';
import PencilSimpleLine from '@components/Student/SVG/PencilSimpleLine.vue';
import ShareNetwork from '@components/Student/SVG/ShareNetwork.vue';
import Users from '@components/Student/SVG/Users.vue';
import ArrowsClockwise from '@components/Student/SVG/ArrowsClockwise.vue';

export default {
  name: 'GroupsFloatingMenuOptions',
  components: {
    ArrowsClockwise,
    Users,
    ShareNetwork,
    PencilSimpleLine,
    UserCircleCheck,
    Trash,
  },
  props: {
    showMenuOptions: { type: Boolean, default: false },
    pendingJoinRequestsCount: { type: Number, default: 0 },
    shareUrl: { type: String, default: null },
    canRenameGroup: { type: Boolean, default: true },
    canDeleteGroup: { type: Boolean, default: false },
  },
  emits: [
    'close-floating-menu-options',
    'open-context',
    'confirm-delete-group',
  ],
  data() {
    return {
      shareGroupLabel: 'Invite housemates',
      isConfirmingDelete: false,
    };
  },
  watch: {
    showMenuOptions(isOpen) {
      if (!isOpen) {
        this.isConfirmingDelete = false;
      }
    },
  },
  methods: {
    startDeleteConfirm() {
      this.isConfirmingDelete = true;
    },
    cancelDeleteConfirm() {
      this.isConfirmingDelete = false;
    },
    confirmDelete() {
      this.isConfirmingDelete = false;
      this.$emit('confirm-delete-group');
      this.$emit('close-floating-menu-options');
    },
    async copyShareUrlToClipboard(url) {
      if (!url) {
        return false;
      }

      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        return true;
      }

      if (typeof document === 'undefined') {
        return false;
      }

      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      const copied = document.execCommand('copy');
      document.body.removeChild(textarea);

      return copied;
    },
    async handleGroupShare() {
      if (!this.shareUrl) {
        //TODO add error message styling - UX
        this.shareGroupLabel = 'Error!';
        return;
      }

      try {
        let shared = false;

        if (navigator.share) {
          try {
            await navigator.share({
              title: 'UniHomes',
              text: `Join my housemate group using this link:\n${this.shareUrl}`,
              url: this.shareUrl,
            });
            shared = true;
          } catch (err) {
            // Fall through to clipboard fallback when native share is unavailable/blocked.
            void err;
          }
        }

        if (!shared) {
          const copied = await this.copyShareUrlToClipboard(this.shareUrl);

          if (copied) {
            //TODO add copy message styling - UX
            this.shareGroupLabel = 'Link copied';
          } else {
            this.shareGroupLabel = 'Error!';
          }
        }
      } catch (err) {
        // TODO add error message styling - UX
        // User cancelled share OR browser blocked it
        this.shareGroupLabel = 'Error!';
        void err;
      } finally {
        setTimeout(() => {
          this.$emit('close-floating-menu-options');
          this.shareGroupLabel = 'Invite housemates';
        }, 3000);
      }
    },
  },
};
</script>
